import {AppBar as MuiAppBar, Box, Toolbar, styled, Typography} from '@mui/material'
import {Link} from 'react-router-dom'
import {PUBLIC_URL} from '../config/env'

export const AppBar = () => {
  return (
    <Box sx={{flexGrow: 1}}>
      <MuiAppBar
        sx={(theme) => ({backgroundColor: theme.palette.background.paper})}
        position='static'
      >
        <Toolbar
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            [theme.breakpoints.up('lg')]: {
              px: 8,
            },
          })}
        >
          <Link to='/'>
            <Box
              sx={{height: '3rem'}}
              component={Logo}
              src={`${PUBLIC_URL}/UAEMOITE.png`}
              alt='UAE Ministry of Industry &amp; Advanced Technology'
            />
          </Link>
          <Logo src={`${PUBLIC_URL}/miite.svg`} alt='Make it in the emirates' />
        </Toolbar>
        <Toolbar
          sx={(theme) => ({
            display: 'flex',
            textTransform: 'uppercase',
            height: '3rem',
            backgroundColor: theme.palette.primary.main,
            fontSize: '2rem',
            [theme.breakpoints.up('lg')]: {
              px: 8,
            },
            [theme.breakpoints.down('md')]: {
              display: 'none',
            },
          })}
        >
          <Typography
            fontFamily='Changa-Bold'
            fontSize={30}
            sx={(theme) => ({
              textShadow: `0 2px 5px ${theme.palette.background.paper};`,
            })}
          >
            Make it in the emirates{' '}
            <Box
              component='span'
              sx={(theme) => ({
                color: theme.palette.secondary.main,
                textShadow: `0 2px 5px ${theme.palette.secondary.main};`,
              })}
            >
              Awards
            </Box>
          </Typography>
        </Toolbar>
      </MuiAppBar>
    </Box>
  )
}

const Logo = styled('img')(() => ({
  height: '5rem',
  py: 2,
}))
